<div class="body-alert">
    <div class="div-alert text-center">
      <img class="mt-4" src="/assets/img/success.png" width="82px" alt="Sucesso">
      <p class="titulo-alert">Atenção!</p>
      <p class="paragrafo">Não há consultas livres suficientes. Serão cobradas consultas excedentes.</p>
      <p class="subtitulo-alert">Deseja confirmar?</p>
      <div class="footer-alert">
        <button class="botao me-3" (click)="fecharAlertPergunta('confirmar')">CONFIRMAR</button>
        <button class="botao-outline" (click)="fecharAlertPergunta('cancelar')">CANCELAR</button>
      </div>
    </div>
</div>
  